<template>
  <div class="payment-section">
    <p :style="themeColor" class="sub-heading">Choose a payment method</p>
    <div class="payment-method-content opacity" id="payment-section">
      <div class="card current-div">
        <!-- Name Fields -->
        <div class="clearfix double-address-fields" v-if="nameFields.length == 2">
          <text-field :customclass="'left'" :config="nameFields[0]" v-model="checkout.data[nameFields[0].name]"> </text-field>
          <text-field :customclass="'right'" :config="nameFields[1]" v-model="checkout.data[nameFields[1].name]"> </text-field>
        </div>

        <text-field :config="nameFields[0]" v-model="checkout.data[nameFields[0].name]" v-if="nameFields.length == 1">
        </text-field>

        <!-- Card Details  -->
        <text-field ref="ccNumber" @keyup="getCardType" :config="cardNumberField" v-model="checkout.data[cardNumberField.name]">
          <div class="card-icons" :class="{'identified': !!selectedCardType}">
              <i class="fa fa-cc-visa" aria-hidden="true" :class="{'active' : selectedCardType == 'visa'}" ></i>
              <i class="fa fa-cc-amex" aria-hidden="true" :class="{'active' : selectedCardType == 'amex'}"></i>
              <i class="fa fa-cc-mastercard" aria-hidden="true" :class="{'active' : selectedCardType == 'mastercard'}"></i>
              <i class="fa fa-cc-discover" aria-hidden="true" :class="{'active' : selectedCardType == 'discover'}"></i>
          </div>
        </text-field>

        <!-- TODO handle odd number cases -->
        <div class="expiry-section clearfix">
          <!-- TODO handle expiry -->
          <!-- <text-field :customclass="'left'" :config="expiryField" v-model="checkout.data[expiryField.name]" v-if="expiryField" > </text-field> -->
          <expiry-component :config='expiryFields' :data='checkout.data' ></expiry-component>

          <text-field :customclass="'right'" :attrs="cvvAttrs" :config="cvvField" v-model="checkout.data[cvvField.name]" v-if="cvvField" :maxlength='4'> </text-field>
        </div>

        <div class="address-copy-checkbox" v-if="useBillingInfo || useShippingInfo">
          <template v-if="useShippingInfo">
            <input type="checkbox" id="shippingInfo" v-model="useShippingInfo">
            <label for="shippingInfo">
              {{shippingInfoLabel}}
            </label>
          </template>

          <template v-if="useBillingInfo">
            <input type="checkbox" id="shippingInfo" v-model="useBillingInfo">
            <label for="shippingInfo">
              {{billingInfoLabel}}
            </label>
          </template>
        </div>

        <address-component :fields='checkout.cardInfoAddressFields()' :values="checkout.data" :label="'Card Address'" v-if="checkout.cardInfoAddressFields().length > 0 && !(useBillingInfo || useShippingInfo)"></address-component>

      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import AddressComponent from "./AddressComponent.vue";
  import ExpiryComponent from "./ExpiryComponent.vue";
  import TextField from "./TextField.vue";

  class Constants {
    static get NAME_FIELDS() {
      return [
        "card[first_name]",
        "card[last_name]"
      ]
    }
  }
  export default {
    name: 'payment-details',
    props: ['checkout'],
    components: {
      'address-component': AddressComponent,
      'text-field': TextField,
      'expiry-component': ExpiryComponent
    },
    data() {
      return {
        selectedCardType: undefined,
        useBillingInfo: false,
        useShippingInfo: false
      }
    },
    computed: {

      cvvAttrs() {
        return {
          'cbcard': this.cardNumberField.id
        }
      },

      nameFields() {
        // TODO handle reordering issue
        return this.checkout.cardInfo().fields.filter(({name}) => Constants.NAME_FIELDS.indexOf(name) != -1);
      },

      cardNumberField() {
        return this.checkout.cardInfo().fields.filter(({name}) => name == "card[number]")[0];
      },

      expiryField() {
        return this.checkout.cardInfo().fields.filter(({name}) => name == "card.expiry")[0];
      },

      expiryFields() {
        return this.checkout.cardInfo().fields.filter(({id}) => id.startsWith("card.expiry"));
      },

      cvvField() {
        return this.checkout.cardInfo().fields.filter(({name}) => name == "card[cvv]")[0];
      },

      shippingInfoLabel() {
        var f = this.checkout.cardInfo().fields.filter(({name}) => name == "card.copy_shipping_info")[0];
        return f && f.label;
      },

      billingInfoLabel() {
        var f = this.checkout.cardInfo().fields.filter(({name}) => name == "card.copy_billing_info")[0];
        return f && f.label;
      }
    },
    mounted() {
      var paymentInput = this.$refs.ccNumber.$refs.input;
      jQuery(paymentInput).payment('formatCardNumber');

      this.useBillingInfo = this.checkout.cardInfo().fields.filter(({name}) => name == "card.copy_billing_info").length > 0;
      this.useShippingInfo = this.checkout.cardInfo().fields.filter(({name}) => name == "card.copy_shipping_info").length > 0;

      if(this.useShippingInfo && this.useBillingInfo){
        console.log("Shouldnt happen");
        this.useBillingInfo = false;
        this.useShippingInfo = false;
      }
    },
    methods: {
      getCardType() {
        var tmp = this.$refs.ccNumber && this.$refs.ccNumber.$refs.input;
        this.selectedCardType = ["visa", "mastercard", "amex", "discover"].filter(name => tmp.classList.contains(name))[0];
      }
    }
  }

</script>
<style scoped> 
  .address-copy-checkbox {
    border: none !important;
    margin-top: 10px;
    height: auto;
    min-height: auto !important;
  }

  .address-copy-checkbox input[type=checkbox] {
    width: auto;
  }

  .address-copy-checkbox label {
    color: #80808A;
  }
  .expiry-section {
    overflow: visible;
    box-sizing: content-box !important;
  }
</style>



// WEBPACK FOOTER //
// PaymentDetails.vue?4373b944